export const EXCMDEVICEPERIPHERAL_SHOW_RESET = 'EXCMDEVICEPERIPHERAL_SHOW_RESET'
export const EXCMDEVICEPERIPHERAL_SHOW_SET_ERROR = 'EXCMDEVICEPERIPHERAL_SHOW_SET_ERROR'
export const EXCMDEVICEPERIPHERAL_SHOW_SET_RETRIEVED = 'EXCMDEVICEPERIPHERAL_SHOW_SET_RETRIEVED'
export const EXCMDEVICEPERIPHERAL_SHOW_TOGGLE_LOADING = 'EXCMDEVICEPERIPHERAL_SHOW_TOGGLE_LOADING'
